/**
 * Centralized contact and WhatsApp referral links.
 * Allows configuring the official sales/support WhatsApp via env variable
 * VITE_WHATSAPP_SALES_URL or falls back to standard wa.me format.
 */

export const DEFAULT_WHATSAPP_SALES_BASE = 'https://wa.me/584266103744'
export const DEFAULT_SUPPORT_EMAIL = 'soporte@iridiachat.com'

export function getWhatsAppSalesUrl(customMessage?: string): string {
  const base = (import.meta.env?.VITE_WHATSAPP_SALES_URL as string | undefined) || DEFAULT_WHATSAPP_SALES_BASE
  const message = customMessage || 'Hola IridiaChat, deseo solicitar información sobre la plataforma y la Beta privada.'
  const encoded = encodeURIComponent(message)
  return base.includes('?') ? `${base}&text=${encoded}` : `${base}?text=${encoded}`
}
